import Turbolinks from 'turbolinks';

$(document).on('ajax:beforeSend', '.js-turbolinks-get-form', (e) => {
  e.preventDefault();

  const [xhr, options] = e.detail; // eslint-disable-line no-unused-vars
  const action = window.location.href.includes('search/index?search')
    ? 'replace'
    : (e.currentTarget.dataset.turbolinksGetFormAction || 'replace');

  Turbolinks.clearCache();
  Turbolinks.visit(options.url, { action });
});

$(document).on('ajax:beforeSend', '.js-turbolinks-get-search-form', (e) => {
  e.preventDefault();

  const [xhr, options] = e.detail; // eslint-disable-line no-unused-vars
  let action;

  if (window.innerWidth < 768) {
    action = 'replace';
  } else {
    action = window.location.href.includes('search/index?search') ? 'replace' : 'advance';
  }

  Turbolinks.clearCache();
  Turbolinks.visit(options.url, { action });
});
